// 下载文件流需要安装 js-file-downlad插件
import axios from 'axios'
import { escape } from 'core-js/';
const service = axios.create({
    baseURL : '/',
    timeout : 10000,
    responseType: 'arraybuffer'
})

// 验证Authorization里面是否包含token字段，验证登录yong 
service.interceptors.request.use(config=>{
    // config.headers['Authorization'] = window.sessionStorage.getItem('token');
    return config;
},error=>{
    console.log(error)
})

// 拿到响应的数据去做一些处理。
service.interceptors.response.use(resp=>{
    const headers = resp.headers;
    // 定义正则表达式 校验是否为json字符串
    let reg = RegExp('/application\/json/')
    // 判断headers里面的content-type和我们正则表达式是否匹配
    // 如果响应数据为json走这条
    if(headers['content-type'].match(reg)){
        resp.data = uintToSting(resp.data)
    }else{
        // 流文件下载需要 1.download插件 2.文件名 3.响应类型
        let fileDownload = require('js-file-download');
        let fileName = headers['content-disposition'].slice(20);
        let contentType = headers['content-type'];
        // 做文件名转换，不然文件名中文可能会乱码
        fileName = decodeURIComponent(fileName);
        fileDownload(resp.data,fileName,contentType);
    }
},error=>{
    console.log(error)
})

function uintToSting(uintArray){
    // 编码
    let encodedString = String.fromCharCode.apply(null,Uint8Array(uintArray))
    // 解码
    let decodedString = decodeURIComponent(escape(encodedString))
    return JSON.parse(decodedString)
}

// 定义请求
let base = '';
export const downloadRequest=(params=>{
    return service({
        method:'get',
        url:'/user/downloadFile',
        data: params
    })
})

// 暴露请求
export default service;


// WEBPACK FOOTER //
// ./src/util/download.js